<template>
<div class="auto-complete-wrapper">
    <input type="text" v-model="input" 
        @keydown.enter = "updateInput"
        @keydown.down = "onKeyDown"
        @keydown.up = "onKeyUp"
        @keyup ="onUserInput"
        @touchend ="onUserInput"
        :placeholder="placeholderText"
    >
    <div class="clear-input"
            v-if="input.length"
            @click="clearInput"
            @tap="clearInput"

    >x</div>
    <div class="suggestions-list" v-if="showList && suggestions.length">
        <div v-for="(item, index) in suggestions" class="suggestions-list-item" :class="{'active':(index === currentIndex)}"
            @click="complete(index)"
            @tap="complete(index)"
            :key="index">
            {{ item }}
        </div>
    </div>
</div>
</template>

<script>
export default {
    name: 'Autocomplete',
    props: {
        data:  { type: Array, required: true},
        placeholderText: { type: String, required: false}
    },
    data() {
        return {
            input: '',
            current: '',
            currentIndex: -1,
            showList: false
        }
    },
    computed: {
        suggestions() {
            let arr = this.data.filter(function(item) {
                return item.toLowerCase().indexOf(this.input.toLowerCase()) !== -1 && this.input !== ''
            }.bind(this));

            return Object.values(arr);
        }
    },
    methods: {
        onUserInput(event) {
            // if the user didn't click on enter key
            //console.log('here', 'onUserInput')
            if (event.keyCode !== 13) {
                console.log('show?');
                this.showList = true;
            }
            
        },
        updateInput() {
            // once the user selects the suggestion we need to hide the list
            this.showList = false;
            this.current = this.suggestions[this.currentIndex];
            if(this.current !== undefined) {
                this.input = this.current;
                this.$emit('input', this.current);

                // we need to reset the currentIndex to -1 whenever the suggestions change
                this.currentIndex = -1;
               
            } else {
                // if suggestion was not found
                this.$emit('input', this.input);
                
            }
            
        },
        complete(index) {
            // on clikcing on an element from the suggestions list we need to update the currentIndex
            this.currentIndex = index;
            this.updateInput();
        },
        onKeyUp() {
            if(this.currentIndex > 0) {
                this.currentIndex -= 1;
            }
        },
        onKeyDown() {
            if(this.currentIndex < this.suggestions.length -1) {
                this.currentIndex += 1;
            }
        },
        clearInput() {
            this.input = '';
            this.showList = false;
            this.currentIndex = -1;
            this.updateInput();
        }
    }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>
